import React from 'react'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import { WrappedStoryStateProvider } from 'contexts/Wrapped'
import WrappedLoadingState from './WrappedLoadingState'
import WrappedErrorState from './WrappedErrorState'
import WrappedStoryContent from './WrappedStoryContent'
import useWrappedData from '../hooks/useWrappedData'

const FullPageContainer = styled.div`
  position: fixed;
  inset: 0;
  height: 100vh;
  height: 100dvh;
  z-index: ${zIndex.menuInModal};
  background-color: ${props => props.theme.palette.neutral.default.one};
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
`

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
`

interface Props {
  uuid?: string
  onClose?: () => void
}

function WrappedStoryMobile({ uuid, onClose }: Props) {
  const { hasError, error, state, dispatch, handleRetry, hasContent, showLoadingOverlay } = useWrappedData({ uuid })

  return (
    <FullPageContainer className="is-full-page">
      {hasError && <WrappedErrorState error={error ?? undefined} onRetry={handleRetry} onClose={onClose} />}
      {!hasError && hasContent && (
        <WrappedStoryStateProvider state={state} dispatch={dispatch}>
          <WrappedStoryContent mode="fullPage" onClose={onClose} />
        </WrappedStoryStateProvider>
      )}
      {showLoadingOverlay && (
        <LoadingOverlay>
          <WrappedLoadingState />
        </LoadingOverlay>
      )}
    </FullPageContainer>
  )
}

export default WrappedStoryMobile
